import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import QueryBar from "../../components/QueryBar";
import DoubtView from "./viewDoubt";
import axios from "axios";

const Doubts = () => {
  const getuser = useSelector((state) => state.getuser).result;
  const [searchQuery, setSearchQuery] = useState("");
  const [doubts, setDoubts] = useState([]);
  const [loading, setLoadingDoubts] = useState(false);
  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const filteredQuestions = doubts;

  const handleClearSearch = () => {
    setSearchQuery("");
  };
  const handleFetchDoubts = async () => {
    setLoadingDoubts(true);
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      const res = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/getdoubts${
          getuser?.result?.isTeacher ? "mentor" : "student"
        }?${getuser?.result?.isTeacher ? "mentor" : "student"}=${
          getuser?.result?._id
        }`,
        { headers }
      );
      console.log(res);
      if (res.data) {
        setDoubts(res.data);
      } else {
        alert("No Doubts");
        setDoubts([]);
      }
    } catch (err) {
      console.log("Error fetching doubts", err);
    }
    setLoadingDoubts(false);
  };
  useEffect(() => {
    handleFetchDoubts();
  }, []);
  return (
    <div>
      <QueryBar
        onSearch={handleSearch}
        onClear={handleClearSearch}
        searchQuery={searchQuery}
      />

      {/* Rest of the component */}
      <div className="dropdown mt-2">
        {/* <Link className="btn btn-secondary dropdown-toggle" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Dropdown link
          </Link> */}
        <span className="mt-2">
          <div>Filters:</div>
        </span>
        <button
          type="submit"
          className="bg-white bg-clip-border dropdown-toggle border-2  text-black py-2 px-4 rounded-md focus:outline-none focus:ring focus:border-blue-500"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          Sort By..
        </button>

        <ul className="dropdown-menu">
          <li>
            <Link className="dropdown-item" to="#">
              Newest First
            </Link>
          </li>
          <li>
            <Link className="dropdown-item" to="#">
              Oldest First
            </Link>
          </li>
        </ul>
      </div>
      <section className="mt-3">
        <h2 className="mb-6 mt-2 text-2xl font-bold tracking-tight  text-black-700 lg:mb-8 lg:text-2xl">
          All Doubts asked:
        </h2>
      </section>
      <div className="flex justify-start align-top flex-wrap my-5 gap-3">
        {searchQuery === "" ? (
          doubts &&
          doubts
            ?.slice()
            .reverse()
            .map((doubt, index) => (
              <DoubtView
                key={index}
                doubt1={doubt}
                isTeacher={getuser?.result?.isTeacher}
                userId={getuser?.result?._id}
              />
            ))
        ) : filteredQuestions.length === 0 ? (
          <p className="text-center align-center  text-2xl">No Results Found</p>
        ) : (
          filteredQuestions.map((doubt, index) => (
            <DoubtView
              key={index}
              doubt1={doubt}
              isTeacher={getuser?.result?.isTeacher}
              userId={getuser?.result?._id}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default Doubts;
